/*
---
covers:
  - frontend/src/pages/platform/login.tsx
  - frontend/src/pages/platform/set-password.tsx
  - frontend/src/pages/empresa/identidad/reset-request.tsx
  - frontend/src/components/auth-shell.tsx
  - frontend/src/components/invite-link.tsx
  - backend/app/empresa/identidad/routers/auth.py
revisado: 2026-09-28
---
*/
import type {ManualSeccion} from '../types'

export const seccion: ManualSeccion = {
  id: 'entrar-a-kairos',
  titulo: 'Entrar a Kairos',
  resumen:
    'Tu acceso como trabajador: entrar con tu cédula y tu contraseña, crear la contraseña si tu empresa te invitó, y recuperar el acceso si la olvidaste — incluso si no tienes correo.',
  enCorto: [
    'Su acceso con cédula y contraseña',
    'Cree o recupere su contraseña acá',
    'Sin correo, pida el enlace a su empresa',
  ],
  replayId: 'entrar-a-kairos',
  operaciones: [
    {
      id: 'crear-tu-contrasena-por-invitacion',
      titulo: 'Crear tu contraseña si tu empresa te invitó',
      como: 'Si tu empresa ya te tenía en su nómina, en vez del enlace de registro te comparte un «Enlace de invitación». Al abrirlo ves la pantalla «Cree su contraseña»: escribes la contraseña nueva dos veces y con «Guardar y entrar» quedas adentro, con la sesión ya iniciada.',
      porQueImporta:
        'La contraseña la eliges tú y nadie más la ve: ni la persona encargada en tu empresa ni Kairos pueden definírtela — solo te envían el enlace para que la crees.',
    },
    {
      id: 'iniciar-sesion-con-tu-cedula',
      titulo: 'Entrar con tu cédula y tu contraseña',
      como: 'De ahí en adelante entras siempre por «Iniciar sesión»: tu «Cédula de ciudadanía (CC)» (los 8 a 10 números, sin puntos ni guiones) y tu «Contraseña». No se te pide correo en ningún momento.',
      porQueImporta:
        'Tu identidad en Kairos es tu cédula, no un correo — así entra cualquier trabajador, tenga o no correo electrónico. Es la misma cédula con la que te registraste y con la que tu empresa te reconoce.',
    },
    {
      id: 'recuperar-tu-contrasena',
      titulo: 'Recuperar tu contraseña si la olvidaste',
      como: 'El enlace «¿Olvidó su contraseña?» te lleva a «Restablecer contraseña»: escribes tu cédula y «Enviar enlace». Kairos solo envía el enlace a correos ya confirmados, y la respuesta nunca revela si esa cédula tiene cuenta o no.',
      porQueImporta:
        'Nadie puede averiguar quién está registrado en Kairos probando cédulas ajenas — la pantalla responde igual exista o no la cuenta, y el enlace llega únicamente al correo que tú confirmaste.',
    },
    {
      id: 'pedir-soporte-sin-correo',
      titulo: 'Pedir soporte si no tienes correo',
      como: 'En esa misma pantalla, debajo, está «¿No tiene un correo registrado? Solicitar soporte»: se abre un cuadro para contar tu caso (opcional) y al enviarlo Kairos te avisa que un administrador se pondrá en contacto para devolverte el acceso.',
      porQueImporta:
        'Sin correo no hay enlace de recuperación posible, y Kairos no te deja por fuera por eso: el acceso se restablece por soporte, atendido por una persona, en vez de exigirte un correo que quizá no tengas.',
    },
  ],
}
